import { render, staticRenderFns } from "./AddBadgeDialog.vue?vue&type=template&id=263866b5&scoped=true&"
import script from "./AddBadgeDialog.vue?vue&type=script&lang=ts&"
export * from "./AddBadgeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddBadgeDialog.vue?vue&type=style&index=0&id=263866b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263866b5",
  null
  
)

export default component.exports